import type { SVGProps } from 'react';
const SvgIconQuestionmark = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M7.25 2A3.25 3.25 0 0 0 4 5.25v.5a.75.75 0 0 0 1.5 0v-.5c0-.966.784-1.75 1.75-1.75h2.5a1.75 1.75 0 1 1 0 3.5H9a1.75 1.75 0 0 0-1.75 1.75v1a.75.75 0 0 0 1.5 0v-1A.25.25 0 0 1 9 8.5h.75a3.25 3.25 0 0 0 0-6.5zM8 13.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
  </svg>
);
export default SvgIconQuestionmark;
